import * as React from "react";
import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { InputBase } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ClearIcon from '@mui/icons-material/Clear';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import StraightIcon from '@mui/icons-material/Straight';
import Pagination from '@mui/material/Pagination';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircularProgress from '@mui/material/CircularProgress';
import { formatDateYMD } from "../util/helper"

const TableSearch = ({rows, columns, totalPage, onSearch, loading}) => {
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage]= useState(1);
  const [sort, setSort] = useState({column:"created", order:""});

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleChangePage = (event, value)=>{
    setCurrentPage(value)
    onSearch({searchText, currentPage: value, sort}); // call the callback function with the search parameters
  }

  const handleSearch =()=>{
    setCurrentPage(1)
    onSearch({searchText, currentPage, sort}); // call the callback function with the search parameters
  }

  const handleEnter =(event)=>{
    if(event.key === "Enter") { 
      handleSearch()
    }
  }
  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleChangeDataSort = (field)=>{
    if (sort.column==field && !sort.order){
      setSort({column:field, order:"-"})
      onSearch({searchText, currentPage, sort:{column:field, order:"-"}}); 
    }
    else{
      setSort({column:field, order:""})
      onSearch({searchText, currentPage, sort:{column:field, order:""}}); 
    }  
  }


  return (
    <Box
      sx={{
        backgroundColor: "#f1f9ff",
        paddingTop: "40px",
        borderRadius: "4px",
      }}
    >
      <Box width="98%" margin="auto">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={10}>
            <InputBase
              placeholder="Search for domain or brand"
              onChange={handleSearchTextChange}
              onKeyPress={handleEnter}
              sx={{
                width: "100%",
                backgroundColor: "white",
                border: "2px solid #2699fb",
                borderRadius: "50px",
                padding: "7px 16px 7px 16px",
                fontSize: "15px",
                color: "#42A7FF",
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Typography
              sx={{
                borderRadius: "5px",
                padding: "9px 16px 9px 16px",
                backgroundColor: "#2699fb",
                color: "white",
                fontWeight: "bold",
                fontSize: "17px",
                cursor: "pointer",
              }}
              onClick={handleSearch}
            >
              Search
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box width="100%" margin="20px auto 0px">
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "#f1f9ff",
            borderRadius: "none",
            boxShadow: "none",
          }}
        >
          <Table sx={{ minWidth: 750 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns?.map((colum) => (
                  <TableCell
                    key={colum.field}
                    sx={{
                      // width:`${colum.width}`,
                      cursor: "pointer",
                      borderBottom: "1px solid #808182 !important",
                    }}
                    onClick={() => handleChangeDataSort(colum.field)}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#707070",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      {colum?.headerName}
                      {colum.field == sort.column ? (
                        sort.order ? (
                          <ArrowDropDownIcon sx={{ color: "black" }} />
                        ) : (
                          <ArrowDropUpIcon sx={{ color: "black" }} />
                        )
                      ) : (
                        ""
                      )}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {loading?"":<TableBody sx={{ position: "relative" }}>
              {rows?.map((row, index) => (
                <TableRow
                  key={`${row.domain}-${index}`}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "td, th": {
                      color: "#707070",
                      fontWeight: "bold",
                      fontSize: "16px",
                    },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ width: "18%", wordBreak: "break-all" }}
                  >
                    {row.domain}
                  </TableCell>
                  <TableCell sx={{ width: "20%", wordBreak: "break-all" }}>
                    {row.url == "other" ? (
                      row.url
                    ) : (
                      <a href={row.url} target="_blank" rel="noopener">
                        {row.url}
                      </a>
                    )}
                  </TableCell>
                  <TableCell>{row.brand}</TableCell>
                  <TableCell>{row.score}</TableCell>
                  <TableCell align="center">
                    {row.is_alive ? (
                      <RadioButtonUncheckedIcon sx={{ fontSize: "10px" }} />
                    ) : (
                      <ClearIcon sx={{ fontSize: "10px" }} />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.html ? (
                      <StraightIcon
                        onClick={() => openInNewTab(row.html)}
                        sx={{
                          color: "#43A5F5",
                          fontSize: "20px",
                          transform: "rotate(45deg)",
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      <HorizontalRuleIcon sx={{ fontSize: "10px" }} />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.screenshot ? (
                      <StraightIcon
                        onClick={() => openInNewTab(row.screenshot)}
                        sx={{
                          color: "#43A5F5",
                          fontSize: "20px",
                          transform: "rotate(45deg)",
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      <HorizontalRuleIcon sx={{ fontSize: "10px" }} />
                    )}
                  </TableCell>
                  <TableCell sx={{ width: "10%"}}>{row.subject_o}</TableCell>
                  <TableCell sx={{ width: "16%"}}>{row.not_before}</TableCell>
                  <TableCell>{row.message_type}</TableCell>
                  <TableCell sx={{ width: "10%"}}>
                    {formatDateYMD(row.created)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>}
          </Table>
          {loading?<Box
            sx={{
              position: "relative",
              width: "100%",
              height: "160px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <CircularProgress sx={{ color: "#2699fb" }} />
            </Box>
          </Box>:""}
        </TableContainer>
      </Box>
      <Box width="100%" padding="40px 0px" position="relative">
        {rows?.length ? (
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            page={currentPage}
            onChange={handleChangePage}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
  );
};

export default TableSearch;
